import React from 'react';
import ContractsAdminLayout from '../components/administration/ContractsAdminLayout';

const ContractsAdminPage = () => <ContractsAdminLayout />;

export default ContractsAdminPage;
